import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KnBrFactSheetMaterialComponent } from './kn-br-fact-sheet-material.component';
import { CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    imports: [
        CommonModule,
        I18nModule,
        RouterModule,
        UrlModule,
        NgbModule,
        ConfigModule.withConfig({
            cmsComponents: {
                KnBrFactSheetMaterialComponent: {
                    component: KnBrFactSheetMaterialComponent,
                },
            },
        } as CmsConfig),
        KnBrFactSheetMaterialComponent,
    ],
})
export class KnBrFactSheetMaterialModule {}
